import React from "react";
import classNames from "classnames";
import moment from "moment";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import { LogRenderContext } from "../LogRenderer";

const Resumed = ({ name, id, updatedAt, updatedBy }) => {
  const { log } = React.useContext(LogRenderContext);
  const { statusChangeRequest } = log.changedFields;
  return (
    <div className={styles.tabContainer}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div className={styles.badgeContainer}>
          {!!name && <div className={styles.campaignName}>{name}</div>}
          <div className={classNames(styles.badge, styles.badgeSuccess)}>
            <div>Resumed</div>
          </div>
        </div>
        <GetUpdatedOnBy updatedAt={updatedAt} updatedBy={updatedBy} />
        <InfoBlock
          header="Resume Details"
          className={styles.changeTracking}
          config={[
            {
              title: "Resumed From",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.fromDate
                ? moment(statusChangeRequest.fromDate).format("MMM DD, YYYY, h:mm A")
                : undefined,
            },
            {
              title: "Comments",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.comments,
            },
            {
              title: "Name & ID",
              size: {
                sm: 6,
                xs: 6,
              },
              value: `${name} (${id})`,
            },
          ]}
        />
      </div>
    </div>
  );
};
export default Resumed;
